/* ==========================================================================
   One Temperature LP — Vanilla JS（React実装の置き換え）
   依存: なし。body.one-temperature 配下の要素にのみ作用する
   ========================================================================== */
(function () {
  'use strict';

  // body にクラスがついていなければ何もしない（誤読込防止）
  if (!document.body.classList.contains('one-temperature')) return;

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---- IntersectionObserver: Reveal / WipeImage / Trio venn -----------------
  function initReveal() {
    var targets = document.querySelectorAll('.ot-reveal, .ot-wipe, .ot-trio');
    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) {
        el.classList.add('is-visible', 'is-in');
      });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        if (el.classList.contains('ot-trio')) {
          el.classList.add('is-in');
        } else {
          el.classList.add('is-visible');
        }
        io.unobserve(el);
      });
    }, { threshold: 0.2 });
    targets.forEach(function (el) { io.observe(el); });
  }

  // ---- Nav: hero を抜けた所でテーマを切り替え ------------------------------
  function initNav() {
    var nav = document.querySelector('.ot-nav');
    if (!nav) return;
    var hero = document.querySelector('.ot-hero');

    function update() {
      var heroBottom = hero ? hero.offsetTop + hero.offsetHeight - 120 : window.innerHeight;
      var sy = window.scrollY || window.pageYOffset;
      if (sy > heroBottom) {
        nav.classList.add('is-light');
      } else {
        nav.classList.remove('is-light');
      }
      if (sy > 12) {
        nav.classList.add('is-scrolled');
      } else {
        nav.classList.remove('is-scrolled');
      }
    }
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
  }

  // ---- Hero reel: video の自動再生（インラインミュートで） -----------------
  function initHeroReels() {
    var videos = document.querySelectorAll('.ot-hero-reel-tile video');
    videos.forEach(function (v) {
      v.muted = true;
      v.playsInline = true;
      var p = v.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    });
  }

  // ---- Mission: スクロール量に応じて1文字ずつ色を点灯 ----------------------
  function initMission() {
    var section = document.querySelector('.ot-mission');
    var text = document.querySelector('.ot-mission-text');
    if (!section || !text) return;

    // 元テキストを文字単位の <span> に分解
    var raw = text.textContent || '';
    text.textContent = '';
    var spans = [];
    for (var i = 0; i < raw.length; i++) {
      var s = document.createElement('span');
      s.textContent = raw.charAt(i);
      text.appendChild(s);
      spans.push(s);
    }

    function update() {
      var rect = section.getBoundingClientRect();
      var total = rect.height - window.innerHeight;
      if (total <= 0) return;
      var scrolled = Math.max(0, Math.min(1, -rect.top / total));
      var on = Math.floor(scrolled * spans.length * 1.15);
      for (var i = 0; i < spans.length; i++) {
        if (i < on) spans[i].classList.add('is-on');
        else spans[i].classList.remove('is-on');
      }
    }
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
  }

  // ---- Action visual: ビューポートに入ったら video を再生 -------------------
  function initActionVideos() {
    var visuals = document.querySelectorAll('.ot-action-visual video');
    if (!visuals.length) return;
    if (!('IntersectionObserver' in window)) {
      visuals.forEach(function (v) { v.play().catch(function () {}); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting && e.intersectionRatio > 0.25) {
          v.play().catch(function () {});
        } else {
          v.pause();
        }
      });
    }, { threshold: [0, 0.25, 0.6] });
    visuals.forEach(function (v) {
      v.muted = true;
      v.playsInline = true;
      io.observe(v);
    });
  }

  // ---- Numbers: ビューポートに入ったら数値カウントアップ -------------------
  function initCountUps() {
    var els = document.querySelectorAll('[data-count-to]');
    if (!els.length) return;

    function fmt(n, decimals) {
      return n.toFixed(decimals).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function run(el) {
      if (el.dataset.countDone === '1') return;
      el.dataset.countDone = '1';
      var to = parseFloat(el.getAttribute('data-count-to')) || 0;
      var suffix = el.getAttribute('data-count-suffix') || '';
      var prefix = el.getAttribute('data-count-prefix') || '';
      var decimals = parseInt(el.getAttribute('data-count-decimals') || '0', 10);
      var duration = parseInt(el.getAttribute('data-count-duration') || '1400', 10);
      if (prefersReducedMotion) {
        el.textContent = prefix + fmt(to, decimals) + suffix;
        return;
      }
      var start = performance.now();
      function tick(now) {
        var p = Math.min(1, (now - start) / duration);
        var eased = 1 - Math.pow(1 - p, 4);
        var v = to * eased;
        el.textContent = prefix + fmt(v, decimals) + suffix;
        if (p < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }

    if (!('IntersectionObserver' in window)) {
      els.forEach(run);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          run(e.target);
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  // ---- Journey: スクロール連動で横方向に translate ------------------------
  function initJourney() {
    var section = document.querySelector('.ot-journey');
    var track = document.querySelector('.ot-journey-track');
    var bar = document.querySelector('.ot-journey-progress > span');
    if (!section || !track) return;

    var overflow = 0;

    function measure() {
      overflow = Math.max(0, track.scrollWidth - window.innerWidth);
      // セクションの高さ = ビューポート1個 + overflow分
      section.style.height = 'calc(100vh + ' + overflow + 'px)';
    }

    function update() {
      var rect = section.getBoundingClientRect();
      var total = section.offsetHeight - window.innerHeight;
      var p = total > 0 ? Math.min(1, Math.max(0, -rect.top / total)) : 0;
      track.style.transform = 'translate3d(' + (-overflow * p) + 'px, 0, 0)';
      if (bar) bar.style.transform = 'scaleX(' + p + ')';
      // 各 item の reveal
      var items = track.querySelectorAll('.ot-journey-item');
      var n = items.length;
      items.forEach(function (el, i) {
        var threshold = (i / Math.max(1, n - 1)) * 0.85;
        if (p >= threshold) el.classList.add('is-on');
      });
    }

    measure();
    update();
    window.addEventListener('resize', function () { measure(); update(); });
    window.addEventListener('scroll', update, { passive: true });
  }

  // ---- Kinetic +1℃: ホバー位置に応じて文字をズラす -------------------------
  function initKinetic() {
    var wrap = document.querySelector('.ot-kinetic');
    var title = document.querySelector('.ot-kinetic-title');
    if (!wrap || !title) return;
    var chars = title.querySelectorAll('.kchar');
    if (!chars.length) return;

    wrap.addEventListener('mousemove', function (e) {
      var rect = title.getBoundingClientRect();
      var cx = rect.left + rect.width / 2;
      var cy = rect.top + rect.height / 2;
      var dx = (e.clientX - cx) / rect.width;
      var dy = (e.clientY - cy) / rect.height;
      chars.forEach(function (node, i) {
        var mult = 1 + i * 0.5;
        node.style.transform = 'translate(' + (dx * 16 * mult) + 'px, ' + (dy * 14 * mult) + 'px) rotate(' + (dx * 4) + 'deg)';
      });
    });
    wrap.addEventListener('mouseleave', function () {
      chars.forEach(function (n) { n.style.transform = ''; });
    });
  }

  function init() {
    initReveal();
    initNav();
    initHeroReels();
    initMission();
    initActionVideos();
    initCountUps();
    initJourney();
    initKinetic();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
